import React from "react"
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import createTheme from '@mui/material/styles/createTheme';
import blue from '@mui/material/colors/blue';
import orange from '@mui/material/colors/orange';

const theme = createTheme({
  palette: {
    primary: blue,
    secondary : {
      main : orange[400],
      contrastText: "#fff"
    }
  },
});

// eslint-disable-next-line react/display-name,react/prop-types
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export default ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  return <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      {element}
    </ThemeProvider>
    <ReactQueryDevtools initialIsOpen={true} />
  </QueryClientProvider>
}